<template>
  <div ref="dropdownContainer">
    <div class="item">
      <b-form-input
        v-model="searchTerm"
        :placeholder="
          `Search ${theme.charAt(0).toUpperCase() + theme.slice(1)}`
        "
      ></b-form-input>
      <b-spinner
        v-if="loading"
        style="width: 0.9rem; height: 0.9rem"
        variant="primary"
      />
    </div>
    <div style="padding-left: 16px;">
      <b-form-checkbox
        v-if="!hideAllOption"
        ref="selectAllCheckBox"
        @change="handleSelectAll"
        size="lg"
        class="enhanced-title"
        v-model="selectAll"
        :disabled="!localOptions.length"
      >
        <span style="font-size: 14px;">All</span>
      </b-form-checkbox>
    </div>
    <div class="selector-container">
      <b-form-group class="options">
        <b-form-checkbox-group size="lg" v-model="selectedOptions" stacked>
          <b-form-checkbox
            v-for="(item, index) in localOptions"
            :key="index"
            :value="item"
          >
            <span style="font-size: 14px;">
              {{ item.label }}
            </span></b-form-checkbox
          >
        </b-form-checkbox-group>
        <div class="d-flex jusitfy-content-center">
          <span v-if="!localOptions.length">Sorry, no data was found</span>
        </div>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "CustomMultipleSelector",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    theme: {
      type: String,
      default: "Items"
    },
    value: { type: Array, default: () => [] },
    stringQuery: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideAllOption: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localOptions: this.options.map(opt => ({ ...opt, category: this.theme })),
      selectAll: false
    };
  },
  computed: {
    selectedOptions: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", [...value]);
      }
    },
    searchTerm: {
      get() {
        return this.stringQuery;
      },
      set(value) {
        this.$emit("update:stringQuery", value);
      }
    }
  },
  methods: {
    handleSelectAll(event) {
      if (event) {
        this.selectedOptions = this.localOptions;
      } else {
        this.selectedOptions = [];
      }
    }
  },
  watch: {
    options(value) {
      if (value) {
        this.localOptions = this.options;
      }
    },
    selectedOptions(value) {
      if (value) {
        if (
          this.selectAll &&
          this.selectedOptions.length !== this.localOptions.length
        ) {
          this.selectAll = false;
        }
      }
    }
  }
});
</script>

<style scoped>
.selector-container {
  max-height: 500px;
  overflow-y: auto;
  width: auto;
}

.item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: var(--2, 8px) var(--4, 16px);
  align-items: center;
  gap: 20px;
  align-self: stretch;
}

.search-icon {
  background: #fbfbfb !important;
  fill: #363abb;
}

.options {
  display: flex;
  padding: var(--2, 8px) var(--4, 16px);
  align-items: center;
  gap: 20px;
  align-self: stretch;
}

.selector-container::-webkit-scrollbar {
  width: 2px; /* Set the width of the scrollbar */
}

.selector-container::-webkit-scrollbar-thumb {
  background-color: #363abb; /* Set the color of the scrollbar thumb */
  border-radius: 6px; /* Round the edges of the thumb */
  border: 2px solid #363abb;
}

.selector-container::-webkit-scrollbar-thumb:hover {
  background-color: #363abb; /* Change thumb color on hover */
}
</style>
